import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
import { goToCheckout } from '../constants/checkout';
export function FinalCTA() {
  return <section id="comprar" className="min-h-screen flex items-center justify-center py-24 bg-black relative overflow-hidden scroll-mt-20" data-id="element-10">
      <div className="absolute inset-0 bg-hero-glow opacity-60" data-id="element-11"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-12"></div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-5xl mx-auto" data-id="element-14">
          <h2 className="text-6xl md:text-8xl lg:text-9xl font-teko font-bold text-white leading-[0.9] mb-8 drop-shadow-2xl" data-id="element-15">
            EL MEJOR MOMENTO PARA RECUPERAR EL{' '}
            <span className="text-electric-blue text-glow-blue" data-id="element-16">CONTROL</span>{' '}
            ES HOY
          </h2>

          <p className="text-2xl md:text-3xl text-gray-300 font-medium mb-12 max-w-3xl mx-auto" data-id="element-17">
            Comenzá ahora y accedé inmediatamente a todo el sistema.
          </p>

          <div className="mb-12" data-id="element-18">
            <Button variant="primary" size="xl" className="text-2xl px-16 py-8 w-full md:w-auto shadow-[0_0_40px_rgba(255,0,0,0.5)]" onClick={goToCheckout} data-id="element-19">
              QUIERO ACCEDER AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-gray-400 font-medium text-lg" data-id="element-20">
            <div className="flex items-center gap-3" data-id="element-21">
              <Lock className="w-6 h-6 text-gray-500" data-id="element-22" />
              <span data-id="element-23">Compra privada</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-24">
              <Zap className="w-6 h-6 text-electric-blue" data-id="element-25" />
              <span data-id="element-26">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-27">
              <CreditCard className="w-6 h-6 text-gray-500" data-id="element-28" />
              <span data-id="element-29">Cuotas disponibles</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}